<template>
  <div>
    <div style="display: flex;flex: 1;width: calc(100% - 45px);">
      <div v-for="field in fields" :style="{ width: 98 / fields.length + '%' }">
        {{ field.placeholder }}
      </div>
    </div>
    <div style="display: flex;" v-for="(item, index) in info">
      <div style="display: flex;flex: 1;justify-content: space-around;">
        <div
          v-for="field in fields"
          :style="{ width: 98 / fields.length + '%' }"
        >
          <Select
            v-if="field.component === 'Select'"
            v-model="info[index][field.key]"
            :placeholder="field.placeholder"
            filterable
            clearable
          >
            <Option
              v-for="item in field.options"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
          <component
            v-else
            :is="field.component"
            v-model="info[index][field.key]"
            :placeholder="field.placeholder"
          ></component>
        </div>
      </div>
      <div>
        <Button
          @click="add(index)"
          type="primary"
          style="margin: 0 10px;"
          size="small"
          >+</Button
        >
        <Button
          :disabled="info.length <= 1"
          @click="del(index)"
          type="error"
          size="small"
          >-</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      defaullt: () => ({})
    },
    fields: {
      type: Array,
      default: []
    }
  },
  computed: {
    info() {
      return this.data.row[this.data.field.key];
    }
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {
    add(index) {
      this.info.splice(index + 1, 0, {});
    },
    del(index) {
      this.info.splice(index, 1);
    }
  }
};
</script>

<style scoped></style>
